import { observer } from 'mobx-react'

import { IconNoPermission } from '@avantstay/backoffice-vectors'

import * as S from './NoResults.styles'
import { NoResultsIconEmail } from './NoResultsIconEmail'
import { NoResultsIconSMS } from './NoResultsIconSMS'

export interface NoResultsProps {
  type?: 'email' | 'sms' | 'info' | 'permission'
  title?: string
  subtitle?: string
  onReset?: VoidFunction
  className?: string
}

const _NoResults = ({ type = 'info', title, subtitle, onReset, className }: NoResultsProps) => {
  const getIcon = () => {
    switch (type) {
      case 'email':
        return <NoResultsIconEmail />
      case 'sms':
        return <NoResultsIconSMS />
      case 'permission':
        return <IconNoPermission style={{ opacity: 0.1 }} width={80} />
      case 'info':
      default:
        return <S.InfoIcon />
    }
  }
  return (
    <S.Root className={className}>
      {getIcon()}
      <S.Title>{title}</S.Title>
      <S.Subtitle>{subtitle}</S.Subtitle>
      {onReset && <S.ResetButton onClick={() => onReset()}>Reset filters</S.ResetButton>}
    </S.Root>
  )
}

export const NoResults = observer(_NoResults)
